/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/* eslint-disable max-len */
/**
 * Makes a request using the TomTom
 * [Search API - Structured Geocode](STRUCTURED_GEOCODE_URL).
 *
 * Parameters can be passed to the constructor or provided via convenient methods that can be chained until
 * the method {{#crossLink "StructuredGeocode/go:method"}}{{/crossLink}} performs the actual call.
 *
 * The call is asynchronous, therefore the user has two options to receive the response:
 *  - Passing a callback function.
 *  - Use the {{#crossLink "Promise"}}{{/crossLink}} returned by the
 *    {{#crossLink "Services.services.structuredGeocode/go:method"}}{{/crossLink}} method to handle the response.
 *
 * The SDK provides a {{#crossLink "Promise"}}{{/crossLink}} polyfill for browsers (IE<9)
 * without native ECMAScript 6 support.
 *
 * @class structuredGeocode
 * @namespace Services.services
 * @module Services
 * @uses KeyMixin
 * @uses GoMixin
 * @uses LimitMixin
 * @uses OffsetMixin
 * @uses LanguageMixin
 * @uses ProtocolMixin
 * @uses BestResultMixin
 * @uses BatchMixin
 * @constructor
 *
 * @param {Object} [options] Options to be passed to the structured geocoding call,
 *     or an array of such options objects to perform batch request.
 * @param {Function} [options.callback] Callback function to use in case of success.
 * @param {Function} [options.fail=default] Callback function to use in case of failure.
 * @param {"http"|"https"} [options.protocol="https"] The protocol's type.
 * @param {Boolean}  [options.bestResult=false] Return only one result, the best match result.
 *
 * @param {String} [options.countryCode] 2 or 3 country code letters (e.g., FR,ES).
 *     **This option is required** to be defined here or by using the
 *     {{#crossLink "StructuredGeocode/countryCode:method"}}{{/crossLink}} method.
 * @param {Number} [options.limit=10] Maximum number of responses that will be returned.
 * @param {Number} [options.offset=0] Starting offset of the returned results within the full result set.
 * @param {String} [options.language] Language to use in the response.
 *  The list with all the available codes can be found [here](SEARCH_API_SUPPORTED_LANGS_URL).
 * @param {String} [options.streetNumber] Street Number.
 * @param {String} [options.streetName] Street name.
 * @param {String} [options.crossStreet] Cross street name.
 * @param {String} [options.municipality] Municipality (city/town).
 * @param {String} [options.municipalitySubdivision] Municipality subdivision (sub/super city).
 * @param {String} [options.countryTertiarySubdivision] Named area.
 * @param {String} [options.countrySecondarySubdivision] County.
 * @param {String} [options.countrySubdivision] State or province.
 * @param {String} [options.postalCode] Zip or postal code.
 *
 * @example
 * ```javascript
 * function callbackFn(result) {
 *   console.log(result);
 * };
 * tt.services.structuredGeocode({
 *   key: <Your API key>,
 *   countryCode: 'GB'
 * })
 *   .go();
 * ```
 */
/* eslint-enable max-len */

import {SERVICE_TYPES} from 'Core/serviceTypes';
import { structuredGeocodeRest } from '../../rest/structuredGeocode';
import geocodeModel from '../../model/geocode/geocode';
import batchModel from '../../model/geocode/batchGeocode';
import structureGeocodeParameters from './structureGeocodeParameters';
import serviceFactory from '../serviceFactory';

const fields = structureGeocodeParameters();

function checkBestResult(data) {
    const result = Boolean(data.bestResult);
    delete data.bestResult;
    return result;
}

function modifyRequestParams(data) {
    const bestResult = checkBestResult(data);
    if (bestResult) {
        data.limit = 1;
        data.offset = 0;
    }
}

function handleBatchServiceCall(data) {
    data.batchItems.forEach(modifyRequestParams);
    return structuredGeocodeRest.batch(fields, data).then(results => batchModel(results));
}

function handleServiceCall(data) {
    const bestResult = Boolean(data.bestResult);
    modifyRequestParams(data);
    return structuredGeocodeRest.structuredGeocode(fields, data).then((response) => {
        if (bestResult) {
            return geocodeModel(response)[0];
        } else {
            return geocodeModel(response);
        }
    });
}

export const structuredGeocode = serviceFactory(
    fields,
    SERVICE_TYPES.SEARCH,
    'structuredGeocode',
    handleServiceCall,
    handleBatchServiceCall
);



// WEBPACK FOOTER //
// ./services/services/structuredGeocode/structuredGeocode.js